import config from "./config/aws";

export default {
  COGNITO: {
    REGION: config.COGNITO_REGION,
    USER_POOL_ID: config.COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: config.COGNITO_APP_CLIENT_ID,
    oauth: {
      domain: "sindhidryfruits.auth.ap-south-1.amazoncognito.com",
      scope: [
        "phone",
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: "https://sindhidryfruits.live",
      redirectSignOut: "https://sindhidryfruits.live",
      responseType: "code",
    },
    federationTarget: "COGNITO_USER_POOLS",
  },
};
